import { Breadcrumb } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { breadcrumbSegments } from './model/folderTree';

interface FolderBreadcrumbsProps {
    currentPath: string;
    onNavigate: (path: string) => void;
}

const FolderBreadcrumbs = ({ currentPath, onNavigate }: FolderBreadcrumbsProps) => {
    const { t } = useTranslation(['FileNavigator']);
    const segments = breadcrumbSegments(currentPath);

    return (
        <Breadcrumb className="mb-2">
            <Breadcrumb.Item
                active={currentPath === ''}
                href="#"
                onClick={(event) => {
                    event.preventDefault();
                    onNavigate('');
                }}
                className="text-truncate no-select"
            >
                {t('rootFolder')}
            </Breadcrumb.Item>
            {segments.map((segment) => (
                <Breadcrumb.Item
                    key={segment.path}
                    active={segment.path === currentPath}
                    href="#"
                    onClick={(event) => {
                        event.preventDefault();
                        onNavigate(segment.path);
                    }}
                    className="text-truncate no-select"
                >
                    {segment.label}
                </Breadcrumb.Item>
            ))}
        </Breadcrumb>
    );
};

export default FolderBreadcrumbs;
